import { isPlus3xVip } from "@/lib/payment";

type MemberPlanTextProps = {
  vip?: number;
  vipType?: string;
  prefix?: string;
  suffix?: string;
};

export function MemberPlanText({
  vip,
  vipType,
  prefix = "",
  suffix = "",
}: MemberPlanTextProps) {
  const memberName = isPlus3xVip(vip, vipType) ? "Plus 3倍会员" : "Plus 会员";
  return <>{`${prefix}${memberName}${suffix}`}</>;
}

